import React, { useEffect, useState } from "react";
import styles from "./payout.module.css";
import {
  Button,
  FormControl,
  Grid,
  TextField,
  IconButton,
} from "@mui/material";
import { CloudUpload, Delete } from "@mui/icons-material";
import { Typography } from "@mui/material";
import BulkPayoutsTable from "./BulkPayoutsTable";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const BulkPayout = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [error, setError] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const navigate = useNavigate();

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    const validFiles = files.filter((file) => {
      if (file.size > 5 * 1024 * 1024) {
        alert(`${file.name} is too large. Maximum file size is 5MB.`);
        return false;
      }
      return true;
    });
    setUploadedFiles((prev) => [...prev, ...validFiles]);
    validFiles.forEach((file) =>
      localStorage.setItem(`uploaded_file_${file.name}`, file.name)
    );
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const downloadExcel = () => {
    const s3FileUrl =
      "https://my-email-assets-escrowstack.s3.ap-south-1.amazonaws.com/New_Bulk_user.xlsx";

    // Create a temporary anchor element
    const link = document.createElement("a");
    link.href = s3FileUrl;
    link.download = "Bulk_user_import.xlsx"; // Optional: Specify the file name for download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDelete = (fileName) => {
    setUploadedFiles((prev) => prev.filter((file) => file.name !== fileName));
    localStorage.removeItem(`uploaded_file_${fileName}`);
  };

  const formatFileSize = (size) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet);

      setUploadedFiles([file]); // to show it's uploaded
      localStorage.setItem(`uploaded_file_${file.name}`, file.name);
      localStorage.setItem("bulk_data", JSON.stringify(parsedData)); // optional
    };
    reader.readAsArrayBuffer(file);
  };

  const downloadTemplate = (templateType) => {
    let headers = [];
    if (templateType === "adhoc") {
      headers = [
        [
          "Beneficiary name",
          "Mode",
          "A/c no",
          "IFSC",
          "UPI id",
          "Amount",
          "Transaction note",
          "Internal note",
        ],
      ];
    } else {
      headers = [
        [
          "Beneficiary name",
          "Mode",
          "Amount",
          "Transaction note",
          "Internal note",
        ],
      ];
    }

    const worksheet = XLSX.utils.aoa_to_sheet(headers);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Adhoc Template");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const file = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(
      file,
      templateType === "adhoc"
        ? "adhoc_bulk_template.xlsx"
        : "normal_bulk_template.xlsx"
    );
  };

  return (
    <div>
      <div onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
        <span className="pe-2">
          <img src="/arrow-left.svg" />
        </span>
        {"Back"}
      </div>
      <div className={`${styles.title} mt-1`}>Bulk Payout</div>
      {uploadedFiles?.length > 0 ? (
        <BulkPayoutsTable
           data={{ data: JSON.parse(localStorage.getItem("bulk_data") || "[]") }}
          setUploadedFiles={setUploadedFiles}
        />
      ) : (
        <>
          <div className={styles.BulkUserContainer}>
            <div className="d-flex justify-content-end align-items-center gap-2 mb-2">
              <button
                className={`${styles.templateButton} px-5 pt-2 pb-2`}
                onClick={() => downloadTemplate("adhoc")}
              >
                <span className="pe-2">
                  <img src="/download02.svg" />
                </span>
                {"Adhoc Template"}
              </button>
              <button
                className={`${styles.templateButton} px-5 pt-2 pb-2`}
                onClick={() => downloadTemplate("normal")}
              >
                <span className="pe-2">
                  <img src="/download02.svg" />
                </span>
                {"Normal Template"}
              </button>
            </div>
            <div
              className={`${styles.BulkUserupload} ${
                isDragging ? styles.dragging : ""
              }`}
              onDragEnter={handleDragEnter}
              onDragOver={handleDragOver}
              onClick={() => document.getElementById("fileInput").click()}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <div className={styles.BulkUseruploadContainer}>
                <div className={styles.BulkUseruploadContainer1}>
                  <img
                    className={styles.plusCircleImage}
                    alt=""
                    src="/PlaceholderImage.svg"
                  />
                  <div className={styles.BulkUseruploadContainerText}>
                    + Upload only Excel Format document
                  </div>
                </div>
                <div className={styles.BulkUseruploadContainerLink}>
                  <div className={styles.plusCircleSpanCOnatiner}>
                    <img src="/upload.svg" className="mx-2" />
                    <span className={styles.plusCircleSpan}>
                      Drag & drop the file here or{" "}
                      <span
                        style={{
                          color: "#2348AB",
                          textDecoration: "underline",
                        }}
                      >
                        {" "}
                        Click to upload
                      </span>
                    </span>
                    <input
                      className={styles.plusCircleButton}
                      id="fileInput"
                      type="file"
                      accept=".csv, .xlsx, .xls"
                      onChange={(e) => {
                        setError(false);
                        const file = e.target.files[0];
                        if (file) {
                          const fileType = file.name
                            .split(".")
                            .pop()
                            .toLowerCase();
                          if (["csv", "xlsx", "xls"].includes(fileType)) {
                            handleFileChange(e);
                          } else {
                            setError(true);
                          }
                        }
                      }}
                      style={{ display: "none", margin: "10px 0" }}
                    />
                  </div>
                </div>
                {/* {error && (
                  <div className={styles.BulkUseruploadContainerError}>
                    <img
                      className={styles.plusCircleIcon}
                      alt=""
                      src="/x-circle.svg"
                    />
                    Please upload correct file format.
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BulkPayout;
